module.exports = __webpack_public_path__ + "08_face.9c273fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/08_face.png
// module id = KF4y
// module chunks = 0